<template>
  <div id="report">
    <div class="full-overlay">
      <div class="overlay-header">
        <b-container fluid>
          <b-row align-h="center" align-v="center" class="my-md-4">
            <b-col>
            </b-col>
            <b-col cols="7">
              <div class="overlay-subnav text-center" v-if="$route.name != 'Results'" >
                <b-button class="icon--color" style="vertical-align: top;" :disabled="$parent.availableReports.indexOf($parent.openedReport) === 0" variant="link"  :to="$parent.availableReports[$parent.availableReports.indexOf($parent.openedReport)-1]"><icon scale="2" name="angle-left"/></b-button>
                <span class="subnav-progress">
                  <router-link class="item" :key="index" v-for="(report, index) in $parent.availableReports" :class="{'active': report === $parent.openedReport}" :to="report"></router-link>
                </span>
                <b-button class="icon--color" style="vertical-align: top;" :disabled="$parent.availableReports.indexOf($parent.openedReport) >= $parent.availableReports.length -1" variant="link" :to="$parent.availableReports[$parent.availableReports.indexOf($parent.openedReport)+1]"><icon scale="2" name="angle-right"/></b-button>
              </div>
            </b-col>
            <b-col class="text-right">
              <b-button class="icon--color" variant="link" to="/personal/results" id="close-button"><icon name="times" scale="2"/></b-button>
            </b-col>
          </b-row>
        </b-container>
      </div>
      <div class="overlay-content">
        <b-container fluid class="px-0 pt-0 pb-4">
          <b-row align-v="center" align-h="center" class="py-4 mb-5 card--text">
            <b-col cols="12" sm="12" md="10" class="text-center p-3">
              <h1 class="info-headline">Työn kuormitustekijät</h1>
              <h5><span>Kaikessa työssä on kuormittavia asioita ja kuormitus on usein myös vaihtelevaa. Tässä raportissa käydään läpi oma arviosi kuormitustekijöistä ja niiden merkittävyydestä.</span></h5>
            </b-col>
          </b-row>
          <div v-if="topReports.length > 0">
            <b-row align-v="center" align-h="center" class="mt-5 mb-5">
              <b-col cols="12" sm="12" md="10" order-md="2">
                <b-row>
                  <b-col>
                    <h2 class="mb-4">Merkittäviä kuormitustekijöitä</h2>
                    <p>Olet raportoinut merkittäviä kuormitustekijöitä, jotka hallitsemattomina saattavat olla pidemmän päälle haitallisia fyysiselle tai henkiselle terveydellesi.</p>
                    <p>Jos koet työhösi liittyvän kuormituksen liialliseksi, tai että voimavarasi eivät riitä näiden kuormittavien asioiden hallitsemiseen, suosittelemme sinua keskustelemaan asiasta esihenkilön, HR:n tai johdon kanssa ja pyytämään tukea kuormituksen hillitsemiseen. Myös muut työyhteisösi jäsenet saattavat kyetä auttamaan kuormituksesi kanssa.
                    <p>Jos nämä kuormitustekijät vaikuttavan hyvinvointiisi, käänny hyvissä ajoin työterveyden puoleen. Voit halutessasi näyttää tätä raporttia keskustellessasi esimerkiksi työterveyshoitajan kanssa.</p>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
            <b-row align-v="start" align-h="center" class="mb-5" v-for="(result, index) in topReports" :key="index">
              <b-col cols="12" md="6" order-md="1">
                <p class="feedback-title">
                  <span>{{index + 1}}. {{ result.question.question[$i18n.i18next.language] }}</span>
                </p>
              </b-col>
              <b-col cols="12" sm="12" md="4" order-md="2">
                <b-row>
                  <b-col>
                    <div class="animated-bar mt-0">
                      <div class="meter" :class="{'activated': true}" :style="{'background': mapColor(result.answer), 'width': $parent.formatPercent(result.answer/6)}"></div>
                    </div>
                    <!-- <p class="tidbit">{{$t('common:updated')}} {{result.updatedAt | moment('from')}}.</p> -->
                  </b-col>
                </b-row>
                <b-row>
                  <b-col>
                    <div class="overall-score mt-2">
                      <span class="--scale">{{result.question.options.find(o => o.value === result.answer).label[$i18n.i18next.language]}}</span>
                    </div>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </div>
          <div v-if="moderateReports.length > 0">
            <b-row align-v="center" align-h="center" class="mt-5 mb-5">
              <b-col cols="12" sm="12" md="10" order-md="2">
                <b-row>
                  <b-col>
                    <h2 class="mb-4">Huomioitavia kuormitustekijöitä</h2>
                    <p>Kaikessa työssä on kuormittavia hetkiä ja kausia. Sinulla saattaa olla ajoittain kuormitustekijöitä, joihin on hyvä kiinnittää huomiota. Seuraa näitä kuormitustekijöitä työarjessa ja keskustele niistä työkavereiden, esihenkilön tai johdon kanssa, jos nämä tekijät alkavat yleistyä tai tuntuvat liiallisilta tai terveydellesi haitallisilta.</p>
                    <p>Muista myös varata aikaa palautumiselle, jotta ajoittainen stressi tai kuormitus ei pääse heikentämään hyvinvointiasi.</p>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
            <b-row align-v="start" align-h="center" class="mb-5" v-for="(result, index) in moderateReports" :key="index">
              <b-col cols="12" md="6" order-md="1">
                <p class="feedback-title">
                  <span>{{index + 1}}. {{ result.question.question[$i18n.i18next.language] }}</span>
                </p>
              </b-col>
              <b-col cols="12" sm="12" md="4" order-md="2">
                <b-row>
                  <b-col>
                    <div class="animated-bar mt-0">
                      <div class="meter" :class="{'activated': true}" :style="{'background': mapColor(result.answer), 'width': $parent.formatPercent(result.answer/6)}"></div>
                    </div>
                    <!-- <p class="tidbit">{{$t('common:updated')}} {{result.updatedAt | moment('from')}}.</p> -->
                  </b-col>
                </b-row>
                <b-row>
                  <b-col>
                    <div class="overall-score mt-2">
                      <span class="--scale">{{result.question.options.find(o => o.value === result.answer).label[$i18n.i18next.language]}}</span>
                    </div>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </div>
          <div v-if="lowReports.length > 0">
            <b-row align-v="center" align-h="center" class="mt-5 mb-5">
              <b-col cols="12" sm="12" md="10" order-md="2">
                <b-row>
                  <b-col>
                    <h2 class="mb-4">Vähäisiä kuormitustekijöitä</h2>
                    <p>Vastauksiesi perusteella nämä tekijät eivät ole merkittäviä työssä kokemasi kuormituksen kannalta. On silti hyvä muistaa, että tilanteet saattavat muuttua ja näitäkin kuormitustekijöitä voi olla hyvä pohtia silloin tällöin.</p>
                    <p>Muut työyhteisössäsi saattavat kokea nämä samat asiat kuormittavammaksi kuin sinä. Toivottavasti voit toimia heille tukena, jos he sitä tarvitsevat.</p>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
            <b-row align-v="start" align-h="center" class="mb-5" v-for="(result, index) in lowReports" :key="index">
              <b-col cols="12" md="6" order-md="1">
                <p class="feedback-title">
                  <span>{{index + 1}}. {{ result.question.question[$i18n.i18next.language] }}</span>
                </p>
              </b-col>
              <b-col cols="12" sm="12" md="4" order-md="2">
                <b-row>
                  <b-col>
                    <div class="animated-bar mt-0">
                      <div class="meter" :class="{'activated': true}" :style="{'background': mapColor(result.answer), 'width': $parent.formatPercent(result.answer/6)}"></div>
                    </div>
                    <!-- <p class="tidbit">{{$t('common:updated')}} {{result.updatedAt | moment('from')}}.</p> -->
                  </b-col>
                </b-row>
                <b-row>
                  <b-col>
                    <div class="overall-score mt-2">
                      <span class="--scale">{{result.question.options.find(o => o.value === result.answer).label[$i18n.i18next.language]}}</span>
                    </div>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </div>
          <div v-else class="text-center">
            {{ $t('personal-results:results-not-available') }}
          </div>
        </b-container>
      </div>
      <div class="overlay-footer d-none d-md-block">
        <b-container fluid>
          <b-row align-h="center">
            <b-col class="text-center mt-3 mb-3 my-md-4">
            </b-col>
          </b-row>
        </b-container>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'

export default {
  data () {
    return {
      report: 'psychosocial-workload'
    }
  },
  async mounted () {
    this.$parent.openedReport = 'psychosocial-workload'
    this.loadReport()
  },
  methods: {
    loadReport: function () {
      if (!this.personalPsychosocialWorkloadReport) {
        this.$store.dispatch('loadPersonalPsychosocialWorkloadReport')
      }
    },
    mapColor: function (answer) {
      const colors = {
        0: '#09AF5A',
        1: '#09AF5A',
        2: '#09AF5A',
        3: '#E88F00',
        4: '#C32F42',
        5: '#C32F42',
        6: '#C32F42'
      }
      return colors[answer]
    }
  },
  computed: {
    ...mapGetters(['personalPsychosocialWorkloadReport']),
    topReports: function () {
      if (this.personalPsychosocialWorkloadReport && this.personalPsychosocialWorkloadReport.choice) {
        return this.personalPsychosocialWorkloadReport.choice.filter(r => r.answer > 3)
      } else {
        return []
      }
    },
    moderateReports: function () {
      if (this.personalPsychosocialWorkloadReport && this.personalPsychosocialWorkloadReport.choice) {
        return this.personalPsychosocialWorkloadReport.choice.filter(r => r.answer <= 3 && r.answer > 2)
      } else {
        return []
      }
    },
    lowReports: function () {
      if (this.personalPsychosocialWorkloadReport && this.personalPsychosocialWorkloadReport.choice) {
        return this.personalPsychosocialWorkloadReport.choice.filter(r => r.answer <= 2)
      } else {
        return []
      }
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
